import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { tr } from "../lib/i18n";

/* Elegant per-letter reveal — soft blur-fade rise, staggered left to right */
const DecodeText = ({ text, className = "", delay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const t = tr(text);

  if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return <span className={className}>{t}</span>;
  }

  const words = t.split(" ");
  let idx = 0;
  return (
    <span ref={ref} aria-label={t}>
      {words.map((w, wi) => (
        <span key={`${w}-${wi}`} className="inline-block whitespace-pre">
          {w.split("").map((ch, ci) => {
            const i = idx++;
            return (
              <motion.span
                key={`${w}-${ch}-${ci}`}
                className={`inline-block will-change-transform ${className}`}
                initial={{ opacity: 0, y: "0.35em" }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{
                  delay: delay / 1000 + i * 0.03,
                  duration: 0.7,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                {ch}
              </motion.span>
            );
          })}
          {wi < words.length - 1 ? " " : ""}
        </span>
      ))}
    </span>
  );
};

export default DecodeText;
